import React, { useEffect, useState } from 'react';
import { getConfig } from '../config';
import { PublicSearchResult } from '../services/api';
import { useContent } from '../contexts/ContentContext';
import ContentPageHeader from './PageHeader';

export default function WorkflowIndex({ embedded = false }: { embedded?: boolean }) {
    const { content, language, t } = useContent();
    const groupLabel = (key: string) => content.ui[language].search.group[key as keyof typeof content.ui.jp.search.group] || key;
    const [groups, setGroups] = useState<PublicSearchResult['groups'] | null>(null);
    const [error, setError] = useState('');
    const [attempt, setAttempt] = useState(0);
    const selected = new URLSearchParams(window.location.search).get('group');
    useEffect(() => {
        const controller = new AbortController();
        setError(''); setGroups(null);
        fetch(`${getConfig().apiHost.replace(/\/+$/, '')}/get_index.php?type=workflow`, { signal: controller.signal })
            .then(response => { if (!response.ok) throw new Error('http'); return response.json(); })
            .then(data => {
                if (!data.groups || typeof data.groups !== 'object' || Array.isArray(data.groups)
                    || Object.values(data.groups).some((group: any) => !group || !Array.isArray(group.values) || group.values.some((value: any) => !value || typeof value.slug !== 'string' || typeof value.label !== 'string' || !Number.isInteger(value.count) || value.count < 0))) throw new Error('invalid');
                if (!controller.signal.aborted) setGroups(data.groups);
            })
            .catch(err => { if (!controller.signal.aborted) setError(err.message); });
        return () => controller.abort();
    }, [attempt]);
    const group = selected ? groups?.[selected] : null;
    const title = group ? groupLabel(selected!) : t('searchWorkflowIndex.text2');
    const back = selected && <a className="lab-button" href="/?page=workflow">{t('searchWorkflowIndex.text4')}</a>;
    const heading = embedded ? <><h2 className="mb-4 text-2xl font-bold">{title}</h2><p className="mb-6">{t('searchWorkflowIndex.text3')}</p>{back}</> : <ContentPageHeader title={title} description={t('searchWorkflowIndex.text3')} actions={back} />;
    if (error) return <>{heading}<div role="alert"><p>{t('search.error')}</p><button className="lab-button" onClick={() => setAttempt(value => value + 1)}>{t('common.retry')}</button></div></>;
    if (!groups) return <>{heading}<p role="status">{t('searchWorkflowIndex.text1')}</p></>;
    return <section className="lab-content-page dark:text-gray-100 ivory:text-coffee-800">
        {heading}
        {selected && !group ? <p>{t('searchWorkflowIndex.text5')}</p> : group ? (
            group.values.length ? <ul className="flex flex-wrap gap-3">{group.values.map(value => <li key={value.slug}>
                <a className="inline-block rounded-lg border bg-white p-4 dark:bg-gray-800 ivory:bg-coffee-50" href={`/?page=search&${encodeURIComponent(selected!)}=${value.slug}`}>
                    {value.label} <span className="text-sm">({t('search.count', { count: value.count })})</span>
                </a>
            </li>)}</ul> : <p>{t('searchWorkflowIndex.text7')}</p>
        ) : <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">{Object.entries(groups).map(([key, data]) => <li key={key}>
            <a className="block rounded-lg border bg-white p-4 dark:bg-gray-800 ivory:bg-coffee-50" href={`/?page=workflow&group=${encodeURIComponent(key)}`}>
                <span className="font-semibold">{groupLabel(key)}</span><span className="ml-3 text-sm">{t('search.values', { count: data.values.length })}</span>
            </a>
        </li>)}</ul>}
    </section>;
}
